import { globalFetch } from './globalActions';
import { FBT_SUCCESS, FBT_IS_LOADING, FBT_HAS_ERRORED } from './types';
import { getItemName } from '../mys4c_helpers';

///////////
// FBT Feed //
///////////

export function fetchFBT() {
  return globalFetch({
    urlPath: `fbt`,
    urlSrc: 1, // FEED_URLSRC_DATA - uses dataFeedsBaseUrl which handles www vs test3
    reducerIsLoading: FBT_IS_LOADING,
    reducerError: FBT_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchFBTSuccess(itemObj));
    },
  });
}

export function fetchFBTSuccess(items) {
  let fbt = null;

  if (items && typeof items === 'object' && items.fbt) {
    fbt = items.fbt;

    // Set FBT as session token if user is not authenticated
    // Note: The auth check will be handled in the component where we have access to Redux state
    if (fbt) {
      window.bws_session_token = fbt;
      // Generate and set itemName for FBT
      const itemName = getItemName('live', fbt);
      if (itemName) {
        window.itemName = itemName;
      }
    }
  }

  return {
    type: FBT_SUCCESS,
    payload: fbt,
  };
}
